export default {
  Home: {
    title:
      "Projetsolaire.com {'|'} Installer Panneaux Solaires avec Artisan RGE",
    description:
      "Avec projetsolaire.com, découvrez 3+ devis gratuits à -40% des prix du marché, de milliers d'artisans photovoltaïques et batteries en autoconsommation.",
    //title: "Projetsolaire.com {'|'} Plateforme communautaire d'énergie solaire",
    //description: "Avec projetsolaire.com, découvrez 3+ devis gratuits photovoltaïque à -40% des prix du marché, d'artisans de panneaux solaires et batteries en autoconsommation.",
  },
  LeadFlow: {
    title:
      "Potentiel Solaire - Étude horaire sur 25 ans {'|'} projetsolaire.com",
    description:
      "Découvrez votre autoconsommation photovoltaïque avec analyse de l'historique horaire du Linky. Gratuit et sans engagements. Zéro démarchage.",
  },
  ResaleAgreements: {
    title: "Comparez les alternatives à EDF OA",
    description:
      "Consultez les alternatives à EDF OA. Choisissez entre un contrat ou une batterie virtuelle et laissez projetsolaire vous accompagner dans votre démarche.",
  },
  About: {
    title:
      "Engagements de l'Acteur Français du Solaire {'|'} projetsolaire.com",
    description:
      "Découvrez la mission et l'équipe du N°1 bureau d'études photovoltaïque en France, et sa vision de l'informatique au service de la filière française du solaire.",
  },
  HelpHome: {
    title:
      "Manuel d'utilisation et astuces - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpHouseholder: {
    title:
      "Assistance pour Propriétaires - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderYourAccountGuideParentAll: {
    title: "Votre portail internet - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderPaymentsGuideParentAll: {
    title:
      "Paiements, tarification et remboursements - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderPresentationGuideParentAll: {
    title:
      "Choisir son système solaire - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderQuotingGuideParentAll: {
    title:
      "Choisir son devis sur-mesure - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderTechnicalVisitGuideParentAll: {
    title: "Valider la faisabilité - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderContractGuideParentAll: {
    title: "Investir dans le solaire - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderAdministrationGuideParentAll: {
    title:
      "Réalisation des démarches administratives - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderInstallationGuideParentAll: {
    title: "Pose & mise en service - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderLegalGuideParentAll: {
    title: "Mentions juridiques - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpInstaller: {
    title: "Service client pour Pros - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerYourAccountGuideParentAll: {
    title: "Votre compte en ligne - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerPresentationGuideParentAll: {
    title:
      "Études photovoltaïques en ligne - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerQuotingGuideParentAll: {
    title: "Mise en relation - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerAdministrationGuideParentAll: {
    title:
      "Gestion administrative automatisée - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerHardwareGuideParentAll: {
    title: "Planification du matériel - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerPaymentsGuideParentAll: {
    title:
      "Paiements, tarification et remboursements - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerProjectManagementGuideParentAll: {
    title: "Vos projets solaires - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerPostInstallationGuideParentAll: {
    title: "Service après-installation - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerLegalGuideParentAll: {
    title: "Mentions juridiques - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  Blog: {
    title: "Astuces, Guides, Centre de renseignements {'|'} projetsolaire.com",
    description:
      "Retrouvez tous nos conseils pour financer, optimiser et entretenir vos panneaux solaires. Autoconsommation, économies d'énergies, aides et démarches.",
  },
  CareerHome: {
    title: "Impact sur climat | Carrières chez projetsolaire",
    description:
      "Envie d'enfin avoir un impact sur le climat ? Rejoignez-nous pour faire quelque chose de grand. ",
  },
  CareerJobPosts: {
    title: "Opportunités à pourvoir | Carrières chez projetsolaire",
    description:
      "Envie d'enfin avoir un impact sur le climat ? Rejoignez-nous pour faire quelque chose de grand. ",
  },
  AmbassadorsHome: {
    title:
      "Parrainez et gagnez 500€ - Programme Ambassadeurs {'|'} projetsolaire.com",
    description:
      "Rejoignez notre programme d'ambassadeurs solaires. Parrainez vos proches et gagnez 500€ par installation. Contribuez à la transition énergétique tout en gagnant de l'argent.",
  },
  InstallerHome: {
    title:
      "Projetsolaire.com {'|'} N°1 de la Gestion tout-en-un photovoltaïque",
    description:
      "Plateforme dimensionnement et administratif pour installateurs de panneaux solaires, artisan RGE, poseur PV, développeur installation photovoltaïque en BT et HTA.",
  },
  InstallerAdministration: {
    title: "N°1 des Démarches Administratives du PV {'|'} projetsolaire.com",
    description:
      "Expert des démarches administratives photovoltaïque. Déléguez et suivez vos dossiers urbanisme, Enedis ou régie ELD, Consuel, EDF OA ou batterie virtuelle.",
  },
  InstallerAdministrationMayor: {
    title: "DP et PC pour Autorisation Mairie {'|'} projetsolaire.com",
    description:
      "Autorisation urbanisme solaire en déclaration préalable ou permis de construire.",
  },
  InstallerAdministrationGridConnection: {
    title:
      "Demande de raccordement  solaire en BT et HTA {'|'} projetsolaire.com",
    description:
      "Démarche Enedis ou ELD avec PTF pour mise en service. Démarche EDF OA ou batterie virtuelle ou ARPE",
  },
  InstallerAdministrationConsuel: {
    title:
      "Attestation Conformité Consuel bleu et violet {'|'} projetsolaire.com",
    description:
      "Logiciel et prestations obtention AC Consuel, schéma unifilaire, SC144 et bureau de contrôle",
  },
  InstallerAdministrationServiceOutline: {
    title:
      "Solution à la carte des Démarches Administratives {'|'} projetsolaire.com",
    description:
      "Expert des démarches administratives photovoltaïque. Déléguez et suivez vos dossiers urbanisme, Enedis ou régie ELD, Consuel, EDF OA ou batterie virtuelle.",
  },
  InstallerDigitalSalesTools: {
    title: "Logiciel de Dimensionnement Solaire PV {'|'} projetsolaire.com",
    description:
      "Études photovoltaïques avec données horaires de consommation du compteur Linky, productible avec masque d'ombres pour audit RGE, en marque blanche.",
  },
  InstallerDesign: {
    title: "Dimensionnement avec projetsolaire",
    description:
      "Nous travaillons avec Aurora solar afin de vous offrir la solution la plus polyvalente et qualitative pour les dimensionnement de vos clients.",
  },
  InstallerFindNewClients: {
    title: "Mise en relation leads PV sans commissions {'|'} projetsolaire.com",
    description:
      "Plateforme en ligne d'appel d'offres pour chantiers photovoltaïques. Le poseur choisit le prix et le matériel. La visite technique est obligatoire.",
  },
  InstallerCaseStudiesHomeOverview: {
    title:
      "Études de cas et Témoignages toutes tailles {'|'} projetsolaire.com",
    description:
      "Avis sur projetsolaire de professionnels, installateurs, poseurs et développeurs du photovoltaïque, cas d'usage sur chantiers HTA, BT>36, particulier.",
  },
  InstallerCaseStudiesHomeAll: {
    title:
      "Tous les témoignages de pros de toutes tailles {'|'} projetsolaire.com",
    description:
      "Avis sur projetsolaire de professionnels, installateurs, poseurs et développeurs du photovoltaïque, cas d'usage sur chantiers HTA, BT>36, particulier.",
  },
  Pricing: {
    title: "Tarifs, prix et coût pour Professionnels {'|'} projetsolaire.com",
    description:
      "Grille tarifaire de projetsolaire et des services numériques, démarches administratives, études, mise en relation, plateforme de gestion de chantiers.",
  },
  ToolsHome: {
    title:
      "Outils gratuits pour installation photovoltaïque {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  ToolEnedisConstructionCost: {
    title:
      "Simulateur Coûts Travaux Raccordement Enedis - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Calcul du coût du renforcement du réseau électrique BT et HTA par Enedis. Alternative au devis PTF de la demande de raccordement photovoltaïque.",
  },
  ToolCarbonModelCalculator: {
    title:
      "Calcul Impact CO2e du Solaire - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  ToolQuoteChecker: {
    title:
      "Vérifier Devis Photovoltaïque - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  ToolHistoricalMonumentChecker: {
    title:
      "Vérifier Urbanisme et Zone ABF - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  Support: {
    title: "Service Client et Contact {'|'} projetsolaire.com",
    description:
      "Discutez avec nos équipes aujourd'hui. Service client 360° disponible via chat, email, téléphone, SMS, et visio. Disponible tous les jours ouvrés sur l'année.",
  },
  SignUp: {
    title: "Inscription {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  SignUpCallback: {
    title: "Confirmation inscription {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  EnableAccountCallback: {
    title: "Activation de votre compte {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  SignIn: {
    title: "Connexion {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  AdminSignIn: {
    title: "Accès privé",
    description:
      "Ne partagez jamais votre mot de passe. Votre mot de passe n'est jamais demandé ailleurs que lors de votre connexion.",
  },
  SupplierSignIn: {
    title: "Connexion - Portail Fournisseurs {'|'} projetsolaire.com",
    description: "Connexion - Fournisseurs description",
  },
  AmbassadorSignIn: {
    title: "Connexion - Portail Ambassadeurs {'|'} projetsolaire.com",
    description: "Connexion - Ambassadeurs description",
  },
  ArchitectSignIn: {
    title: "Connexion - Portail Architecte {'|'} projetsolaire.com",
    description: "Connexion - Architecte description",
  },
  VirtualBatteryProviderSignIn: {
    title: "Connexion - Portail Batterie Virtuelle {'|'} projetsolaire.com",
    description: "Connexion - Batterie Virtuelle description",
  },
  ResetPassword: {
    title: "Réinitialisation du mot de passe {'|'} projetsolaire.com",
    description: "Réinitialiser le mot de passe description",
  },
  ResetPasswordSupplier: {
    title:
      "Réinitialisation du mot de passe - Fournisseurs {'|'} projetsolaire.com",
    description: "Réinitialiser le mot de passe - Fournisseurs description",
  },
  ResetPasswordCallback: {
    title: "Réinitialisation du mot de passe - Callback",
    description: "La plateforme est sécurisé",
  },
  InviteCallbackInstaller: {
    title: "Invitation au compte de l'entreprise {'|'} projetsolaire.com",
    description:
      "Compte personnel pour la gestion de chantiers photovoltaïques. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  InviteCallbackSupplier: {
    title: "Invitation au portail e-commerce {'|'} projetsolaire.com",
    description:
      "Compte de E-commerce en ligne pour vente de matériel photovoltaïque. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  InviteCallbackUser: {
    title:
      "Invitation à l'espace client de son projet solaire {'|'} projetsolaire.com",
    description:
      "Portail client de suivi en ligne de son projet solaire. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  ReportsHome: {
    title: "Rapport du Solaire en France {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France publie son rapport annuel. Découvrez les tendances, renseignements et données de la filière photovoltaïque.",
  },
  HardwareMarketplaceShopHome: {
    title:
      "Achat en ligne et Distribution Matériel Photovoltaïque {'|'} projetsolaire.com",
    description:
      "Découvrez prix compétitifs 100% en ligne module PV, onduleurs, batteries, équipements en énergie solaire.",
  },
  HardwareMarketplaceCompareParent: {
    title:
      "Achat en ligne et Distribution Matériel Photovoltaïque {'|'} projetsolaire.com",
    description:
      "Découvrez prix compétitifs 100% en ligne module PV, onduleurs, batteries, équipements en énergie solaire.",
  },

  InstallerUseCaseSmall: {
    title:
      "Logiciel PV ventes, DP, Consuel pour artisans {'|'} projetsolaire.com",

    description:
      "App de gestion photovoltaïque pour pro RGE. Données Linky, calepinage, étude rentabilité, devis, administratif, etc. sur 1 seul outil.",
  },

  InstallerUseCaseRegional: {
    title:
      "Logiciel PV pour installateur photovoltaïque PME {'|'} projetsolaire.com",

    description:
      "CRM et ERP de gestion chantiers. Données Linky, dimensionnement calepinage, étude rentabilité avec stockage, devis, agenda, ADV, etc. sur 1 seul outil.",
  },

  InstallerUseCaseNational: {
    title:
      "Logiciel pour ETI de gestion de chantiers PV {'|'} projetsolaire.com",

    description:
      "Plateforme tout-en-un photovoltaïque et stockage. Données Linky, dimensionnement, étude rentabilité, urbanisme, raccordement, etc. sur 1 seul outil.",
  },

  InstallerUseCaseSelfInstallation: {
    title:
      "Logiciel PV avec simulateur, ventes, DP, Enedis {'|'} projetsolaire.com",

    description:
      "CRM et ERP photovoltaïque en marque blanche. Données Linky, calepinage, étude rentabilité sur-mesure, devis, administratif, etc. sur 1 seul outil.",
  },

  InstallerUseCaseFranchise: {
    title: "Logiciel PV Ventes et Gestion franchises {'|'} projetsolaire.com",

    description:
      "CRM et ERP photovoltaïque de gestion réseau franchises. Données Linky, dimensionnement, étude rentabilité, devis, ADV, etc. sur 1 seul outil.",
  },

  InstallerUseCaseDeveloper: {
    title:
      "Logiciel Développement PV et Tiers investisseurs {'|'} projetsolaire.com",

    description:
      "CRM et ERP suivi chantiers photovoltaïques et gestion SPV. Données Linky, dimensionnement et productible, AVP, PC, T0, CRD etc. sur 1 seul outil.",
  },

  InstallerUseCasesHome: {
    title:
      "Étude de cas du Logiciel Photovoltaïque CRM/ERP {'|'} projetsolaire.com",
    description:
      "Découvrez la suite de solutions de gestion et suivi de chantiers utilisée par nos centaines de clients artisans, installateurs et développeurs.",
  },

  MyLight150MySmartBattery: {
    title: "Contrat MySmartBattery Mylight150 – Revente solaire",
    description:
      "Découvrez les tarifs de revente solaire du contrat MySmartBattery Mylight150 sur projetsolaire.com.",
  },
  MyLight150MyBattery: {
    title: "Contrat MyBattery Mylight150 – Revente solaire",
    description:
      "Consultez les tarifs du contrat MyBattery Mylight150 pour valoriser votre surplus solaire sur projetsolaire.com.",
  },
  UrbanSolarEnergyBatteryVirtual: {
    title: "Urban Solar Energy – Batterie virtuelle pour professionnels ",
    description:
      "Consultez les tarifs de la batterie virtuelle solaire dédiée aux professionnels sur projetsolaire.com.",
  },
  UrbanSolarEnergyBatteryIndividuals: {
    title: "Urban Solar Energy – Batterie virtuelle pour particuliers",
    description:
      "Accédez aux conditions de stockage virtuel pour particuliers avec Urban Solar Energy sur projetsolaire.com.",
  },
  UrbanSolarEnergySaleLessThan36Kva: {
    title: "Urban Solar Energy – Vente Boost My Surplus <36 kVA",
    description:
      "Consultez les tarifs de revente solaire Boost My Surplus <36 kVA avec Urban Solar Energy sur projetsolaire.com.",
  },
  UrbanSolarEnergySaleMoreThan36Kva: {
    title: "Urban Solar Energy – Vente Boost My Surplus >36 kVA",
    description:
      "Découvrez les tarifs de revente solaire Boost My Surplus >36 kVA avec Urban Solar Energy sur projetsolaire.com.",
  },
  OctopusEnergyPurchaseContractForIndividuals: {
    title: "Octopus Energy – Contrat d'achat pour particuliers",
    description:
      "Consultez les tarifs de revente d’électricité solaire avec Octopus Energy sur projetsolaire.com.",
  },
  EkwateurSurplusWithContract: {
    title: "Ekwateur – Revente avec contrat de surplus solaire",
    description:
      "Accédez aux tarifs du contrat Ekwateur avec engagement pour la revente de votre énergie sur projetsolaire.com.",
  },
  EkwateurSurplusWithoutContract: {
    title: "Ekwateur – Revente de surplus sans contrat",
    description:
      "Découvrez les tarifs sans engagement pour la revente solaire avec Ekwateur sur projetsolaire.com.",
  },
  Kwatts: {
    title: "Kwatts – Revente solaire au prix du marché",
    description:
      "Consultez les prix de rachat indexés sur le marché avec Kwatts directement sur projetsolaire.com.",
  },
  "3ERL": {
    title: "3ERL – Contrat de revente à 70 % du marché",
    description:
      "Consultez les conditions et tarifs de revente solaire à 70 % du marché avec 3ERL sur projetsolaire.com.",
  },
  JPMEEsurplusFixedForIndividuals: {
    title: "JPME E-surplus fixe – Contrat particuliers",
    description:
      "Consultez les tarifs du contrat JPME E-surplus fixe pour particuliers sur projetsolaire.com.",
  },
  JPMEEsurplusFlexForIndividuals: {
    title: "JPME E-surplus flex – Contrat particuliers",
    description:
      "Découvrez les conditions et tarifs flexibles pour particuliers avec JPME sur projetsolaire.com.",
  },
  JPMEEsurplusFixedForProfessionals: {
    title: "JPME E-surplus fixe – Contrat professionnels",
    description:
      "Consultez les tarifs fixes du contrat JPME pour professionnels sur projetsolaire.com.",
  },
  JPMEEsurplusFlexForProfessionals: {
    title: "JPME E-surplus flex – Contrat professionnels",
    description:
      "Accédez aux conditions de revente flexible JPME pour professionnels sur projetsolaire.com.",
  },
  JPMEEbatteryIndividualsLessThan15KVA: {
    title: "JPME – E-batterie particuliers ≤15 kVA",
    description:
      "Découvrez les conditions de stockage avec l’E-batterie JPME jusqu’à 15 kVA sur projetsolaire.com.",
  },
  JPMEEbatteryIndividualsThreePhase: {
    title: "JPME – E-batterie particuliers en triphasé",
    description:
      "Consultez les tarifs JPME pour E-batterie en triphasé dédiée aux particuliers sur projetsolaire.com.",
  },
  JPMEEbatteryLowVoltage: {
    title: "JPME – E-batterie pro en basse tension",
    description:
      "Découvrez les solutions de stockage JPME pour professionnels en basse tension sur projetsolaire.com.",
  },
  JPMEEbatteryHighVoltage: {
    title: "JPME – E-batterie pro en haute tension",
    description:
      "Consultez les offres de stockage JPME pour professionnels en haute tension sur projetsolaire.com.",
  },
  MKSurplusWithValidate: {
    title: "MK-surplus (avec Consuel validée)",
    description:
      "Une installation photovoltaïque avec une attestation de conformité Consuel validée revendez votre surplus de production avec une tarification transparente à l’acteur historique du solaire MonKitSolaire.",
  },
  MKSurplusWithoutValidate: {
    title: "MK-surplus (sans Consuel validée)",
    description:
      "Sans installation photovoltaïque ni attestation de conformité Consuel validée revendez votre surplus de production avec une tarification transparente à l’acteur historique du solaire MonKitSolaire.",
  },
  Sunology: {
    title: "Sunology - Surplus +",
    description:
      " Offre de rachat du surplus de votre installation solaire à un prix fixe avec Sunology.",
  },
  ProjectPostInstallationResaleAgreementEDFOA: {
    title: "EDF OA",
    description:
      "Logiciel photovoltaïque avec outils calepinage, Linky, dimensionnement, PVsyst, urbanisme et ABF, raccordement et Enedis, Consuel et schéma unifilaire, EDF OA.",
  },
}
